import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
import { FiltroSaldosUsuariosZEComponent } from "./filtro";
import * as globals from "app/resources/globals";
import { columnas } from "./columns";

type Entity = models.SaldosUsuariosZEViewDTO;
const resource = resources.SaldosUsuariosZE;
interface State {
    filtro: models.FiltroSaldosUsuariosZE;
}

interface Props {
    session: models.Session;
}

class SaldosUsuariosZEListNoRX extends React.PureComponent<Props,State> {
    modalManager = kea.createModalManager();

    constructor(props) {
        super(props);
        this.state = { filtro: {} };
    }

    onRegresar = () => history.go('../');
    filtro = (state: State) => state.filtro;

    private items = createSelectorRx(this.filtro, filtro => {
        const obs = observeResource(resource.ConsultarMovimiento, filtro);
        return obs;
    });

    render() {
        
        const cols = columnas();
        const items = this.items(this.state);
        return (
            <div>
                <kea.Title titulo="Movimientos de proveedores de zona extendida" onRegresar={this.onRegresar} />
                <FiltroSaldosUsuariosZEComponent value={this.state.filtro} onChange={filtro => this.setState({ filtro })} session={ this.props.session } />
                <kea.Grid2 columnas={cols} cookieKey={"SaldosUsuariosZEViewCookieKey"} items={items} getKey={x => x.IdRegistro} />
                {this.modalManager.component}
            </div>
        )
    }
}
const SaldosUsuariosZEListRX = componentToRx(SaldosUsuariosZEListNoRX);

export class SaldosUsuariosZEList extends React.PureComponent {
    render() {
        const session = resources.User.SessionRx;
        return (
            <SaldosUsuariosZEListRX
                session={resources.User.SessionRx}
            />
        )
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/actividadesusuariosze/list/list.tsx